// extracted by mini-css-extract-plugin
export var fullHeightState = "_5f-7";
export var headerCell = "_5f-1";
export var loadingStateCell = "_5f-4";
export var rowWrapper = "_5f-3";
export var standaloneTable = "_5f-8";
export var standaloneTableWithBodyFill = "_5f-9";
export var stateCell = "_5f-5";
export var table = "_5f-0";
export var tableBodyFiller = "_5f-6";
export var white = "_5f-2";